import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import withStyles from '@mui/styles/withStyles';
import { RAKUNA_COLOR, HOVER_PRIMARY_COLOR } from '../../shared/Constants';

const styles = () => ({
  root: {
    textTransform: 'none',
    width: '100%',
    backgroundColor: RAKUNA_COLOR,
    fontSize: '0.9375rem',
    color: '#fff',
    '&:hover': {
      backgroundColor: HOVER_PRIMARY_COLOR,
      color: '#fff',
    },
    '&:press': {
      backgroundColor: HOVER_PRIMARY_COLOR,
      color: '#fff',
    },
    '&:focus': {
      backgroundColor: HOVER_PRIMARY_COLOR,
      color: '#fff',
    },
  },
});

const PrimaryButton = ({ classes, text, ...rest }) => (
  <Button
    {...rest}
    variant="contained"
    className={classes.root}
    disableElevation
    disableFocusRipple
  >
    {text}
  </Button>
);

PrimaryButton.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  text: PropTypes.string.isRequired,
};

export default withStyles(styles)(PrimaryButton);
